<template lang="pug">
div
  .qr-print(:style="qrPrintStyles")
    .qr-print-title(v-if="title") {{ title }}
    .qr-print-text
      div(v-for="text in texts", :key="text.label")
        span {{ text.label }}
        span.qr-print-text__value {{ text.value }}
    .qr-print-qr(:style="{ width: `${qrWidthAsPixels}px` }")
      vue-qrcode(:value="url", :options="{ width: qrWidthAsPixels, margin: 0, errorCorrectionLevel: 'Q' }", tag="svg")
      img.qr-print-image(:src="require('../../../assets/icons/print/qr-icon.svg')")
</template>

<script setup>
import VueQrcode from "@chenfengyuan/vue-qrcode";
import { computed } from "vue";

const emit = defineEmits(["mounted"]);

const props = defineProps({
  title: { type: String, default: () => "", required: false },
  texts: { type: Array, default: () => [], required: false },
  url: { type: String, default: () => "", required: false },
  layout: { type: String, default: () => "grid" },
  paperWidth: { type: Number || String, default: () => 0 },
  paperHeight: { type: Number || String, default: () => 0 },
});

const paperWidth = computed(() => Number(props.paperWidth));
const paperHeight = computed(() => Number(props.paperHeight));
const widthAsPixels = 263;

const heightAsPixels = computed(() => {
  return widthAsPixels * (paperHeight.value / paperWidth.value);
});
const qrWidthAsPixels = computed(() => {
  if (props.layout === "linear") {
    return heightAsPixels.value / 2;
  } else {
    return 164;
  }
});

const qrPrintStyles = computed(() => {
  if (props.layout === "linear") {
    return {
      width: `${widthAsPixels}px`,
      height: `${heightAsPixels.value}px`,
    };
  } else {
    return {
      width: `${widthAsPixels}px`,
      height: "280px",
    };
  }
});
</script>

<style lang="scss">
@import "../../../assets/styles/printQr/qr.scss"; // This style has separate import and injected in new tab
</style>
